import React from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { URL } from "../url";
// component
import { LoadingScreen } from "../../../component/loading";
import RequireScreen from "../../01_Require/require";
// redux
import { isLoggedSelector } from "../../../store/auth/auth.selector";
import { ownerSelector } from "../../../store/role/role.selector";
import { activeStaffSelector } from "../../../store/staff/staff.selector";

const PrivateRoute = (props) => {
  // -------------------------- VAR --------------------------
  let location = useLocation();
  const element = props?.element;
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  const owner = useSelector(ownerSelector);
  const staff = useSelector(activeStaffSelector);
  const logged = useSelector(isLoggedSelector);
  const active = owner?.active || staff || false;

  // console.log({ active });

  // -------------------------- FUNCTION --------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN --------------------------
  if (logged === null) {
    return <LoadingScreen />;
  }
  if (logged === false) {
    return <Navigate to={URL.home} exact state={{ from: location }} replace />;
  }
  if (staff !== null && active === false) {
    return <RequireScreen />;
  }
  return element;
};

export default PrivateRoute;
